import React from 'react';
import {
  MessageSquare,
  TrendingUp,
  Workflow,
  Shield,
  Coins,
  Code,
  Copy,
  Mail,
  Timer,
  GitBranch,
  Zap,
  Calendar,
  Webhook,
  Play,
} from 'lucide-react';
import type {
  WorkflowCategory,
  TriggerType,
  ActionType,
  CategoryConfigItem,
  TriggerConfigItem,
  ActionConfigItem,
} from './automationTypes';

export const getCategoryConfig = (t: (key: string, fallback: string) => string): Record<WorkflowCategory, CategoryConfigItem> => ({
  engagement: { label: t('auto_cat_engagement', 'Engagement'), color: 'bg-blue-500', icon: <MessageSquare size={16} /> },
  growth: { label: t('auto_cat_growth', 'Growth'), color: 'bg-green-500', icon: <TrendingUp size={16} /> },
  content: { label: t('auto_cat_content', 'Content'), color: 'bg-purple-500', icon: <Workflow size={16} /> },
  moderation: { label: t('auto_cat_moderation', 'Moderation'), color: 'bg-orange-500', icon: <Shield size={16} /> },
  monetization: { label: t('auto_cat_monetization', 'Monetization'), color: 'bg-yellow-500', icon: <Coins size={16} /> },
  custom: { label: t('auto_cat_custom', 'Custom'), color: 'bg-gray-500', icon: <Code size={16} /> },
});

export const getTriggerConfig = (t: (key: string, fallback: string) => string): Record<TriggerType, TriggerConfigItem> => ({
  engagement_threshold: {
    label: t('auto_trigger_engagement', 'Engagement Threshold'),
    icon: <TrendingUp size={16} />,
    description: t('auto_trigger_engagement_desc', 'Trigger when engagement hits a threshold'),
  },
  schedule: {
    label: t('auto_trigger_schedule', 'Schedule'),
    icon: <Calendar size={16} />,
    description: t('auto_trigger_schedule_desc', 'Trigger on a recurring schedule'),
  },
  webhook: {
    label: t('auto_trigger_webhook', 'Webhook'),
    icon: <Webhook size={16} />,
    description: t('auto_trigger_webhook_desc', 'Trigger via external webhook'),
  },
  manual: {
    label: t('auto_trigger_manual', 'Manual'),
    icon: <Play size={16} />,
    description: t('auto_trigger_manual_desc', 'Trigger manually on demand'),
  },
});

export const getActionConfig = (t: (key: string, fallback: string) => string): Record<ActionType, ActionConfigItem> => ({
  cross_post: { label: t('auto_action_cross_post', 'Cross-Post'), icon: <Copy size={16} />, category: t('auto_action_cat_publishing', 'Publishing') },
  send_email: { label: t('auto_action_send_email', 'Send Email'), icon: <Mail size={16} />, category: t('auto_action_cat_communication', 'Communication') },
  delay: { label: t('auto_action_delay', 'Delay'), icon: <Timer size={16} />, category: t('auto_action_cat_flow', 'Flow Control') },
  condition: { label: t('auto_action_condition', 'Condition'), icon: <GitBranch size={16} />, category: t('auto_action_cat_flow', 'Flow Control') },
  ai_generate: { label: t('auto_action_ai_generate', 'AI Generate'), icon: <Zap size={16} />, category: t('auto_action_cat_ai', 'AI') },
  custom: { label: t('auto_action_custom', 'Custom'), icon: <Code size={16} />, category: t('auto_action_cat_custom', 'Custom') },
});
